// extracted by mini-css-extract-plugin
module.exports = {"cf38gc2":"cf38gc2","float-cf38gc2":"float-cf38gc2"};